module.exports = __webpack_public_path__ + "static/img/卡片_选中状态@2x.24605495.png";